// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1GLvi","description":"PatientConsentPreview_description__2vm5Q"};